import {
  FullWidthTextComponentTile,
  InfoListTile,
  ITile,
  SdInlineAlertTile,
  TileType,
  VxlText,
} from '@varo/graphql-schema-types';
import React from 'react';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import fullWidthTextComponent from 'shared/legacySDUIAdapters/fullWidthTextComponent';
import { VXLNode } from 'shared/renderer/types';
import { isNotNil } from 'shared/utils/isNotNil/isNotNil';
import { Maybe } from 'shared/utils/types';

import infoListTile from './infoListTile';
import sdInlineAlert from './sdInlineAlert';
import { BorrowingPowerDependencies } from './types';

export const advancedSectionTile = (
  title: Maybe<VxlText>,
  tiles: ITile[],
  dependencies: BorrowingPowerDependencies,
): VXLNode[] => {
  function convertTitleToTile(title: Maybe<VxlText>): Maybe<VXLNode> {
    if (!title) {
      return null;
    }

    return {
      id: 'section-title',
      render: () => <TitleMdText>{title.copy}</TitleMdText>,
    };
  }

  return [
    convertTitleToTile(title),
    ...tiles.flatMap((child: ITile) => {
      if (child.tileType === TileType.FullWidthTextComponentTile) {
        return fullWidthTextComponent(child as FullWidthTextComponentTile);
      } else if (child.tileType === TileType.List) {
        return infoListTile(child as InfoListTile, dependencies);
      } else if (child.tileType === TileType.SdInlineAlertTile) {
        return sdInlineAlert((child as SdInlineAlertTile).alert);
      }
      return null;
    }),
  ].filter(isNotNil);
};
